var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDefaultFileIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8638 2.59693C15.6032 2.48699 15.4014 2.27184 15.3083 2.00479L14.6094 0H2.875C2.32272 0 1.875 0.447715 1.875 1V19C1.875 19.5523 2.32272 20 2.875 20H17.2031C17.7554 20 18.2031 19.5523 18.2031 19V3.58398L15.8638 2.59693Z",
    fill: "url(#paint0_linear_1336_142561)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00789 9.44946C6.55847 9.44946 6.19409 9.81385 6.19409 10.2633C6.19409 10.7127 6.55848 11.0771 7.00789 11.0771C7.4573 11.0771 7.8217 10.7127 7.8217 10.2633C7.8217 9.81384 7.45731 9.44946 7.00789 9.44946ZM10.2631 9.44946C9.81368 9.44946 9.4493 9.81385 9.4493 10.2633C9.4493 10.7127 9.81368 11.0771 10.2631 11.0771C10.7125 11.0771 11.0769 10.7127 11.0769 10.2633C11.0769 9.81384 10.7125 9.44946 10.2631 9.44946ZM13.5183 9.44946C13.0689 9.44946 12.7045 9.81384 12.7045 10.2633C12.7045 10.7127 13.0689 11.0771 13.5183 11.0771C13.9677 11.0771 14.3321 10.7127 14.3321 10.2633C14.3321 9.81384 13.9677 9.44946 13.5183 9.44946Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2031 3.59375C16.2184 3.59375 14.6094 1.98477 14.6094 0Z",
    fill: "#8DD1FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1336_142561",
    x1: 10.0391,
    y1: 0,
    x2: 10.0391,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5DB7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28A2F8"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDefaultFileIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/default-file-icon.879050f3b044ed9ae04d7533618ee24c.svg";